<script>
  const mediaMap = {
    audio_cd: 'Audio CD',
    audio_download: 'Audio Download',
    book: 'Book',
    book_download: 'E-Book Download',
    large_print: 'Large Print',
    movie: 'Movie'
  }

  const genreMap = {
    action_adventure: 'Action/Adventure',
    biography_memoir: 'Biography/Memoirs',
    fantasy: 'Fantasy',
    graphic_novel: 'Graphic Novels',
    historical_fiction: 'Historical Fiction',
    horror: 'Horror',
    humor: 'Humor',
    fiction: 'Literary Fiction',
    mystery: 'Mysteries',
    non_fiction: 'Non-Fiction',
    romance: 'Romance',
    science_fiction: 'Science Fiction',
    young_adult: 'Young Adults'
  }

  export default {
    name: 'select-books-summary',
    props: {
      formData: {
        type: Object,
        required: true
      }
    },
    data: () => ({}),
    computed: {
      formDataFormatted() {
        const formData = JSON.parse(JSON.stringify(this.formData))
        const dataFixed = {}

        //Patron Info
        dataFixed.info = {}
        if (formData?.info?.email_confirm) delete formData.info.email_confirm
        Object.entries(formData.info).forEach(([item, val]) => {
          const itemFixed = item.replaceAll('_', ' ')
          dataFixed.info[item] = {
            label: itemFixed,
            value: val
          }
        })

        //Preferred Formats
        dataFixed.formats = []
        formData.formats.forEach(f => {
          if (mediaMap?.[f]) {
            dataFixed.formats.push(mediaMap[f])
          }
        })

        //genres
        dataFixed.genres = {}
        Object.entries(formData.genres).forEach(([item, val]) => {
          if (genreMap?.[item]) {
            dataFixed.genres[item] = {
              label: genreMap[item],
              value: this.interestToText(val)
            }
          }
        })

        //questions
        dataFixed.questions = {}
        for (const i in formData.questions) {
          dataFixed.questions[i] = formData.questions[i].replaceAll(`\n`, `<br />`)
        }

        return dataFixed
      }
    },
    methods: {
      interestToText(v) {
        const int = parseInt(v)
        if (v < 0) return 'low'
        if (v > 0) return 'high'
        return 'neutral'
      }
    },
    created() {}
  }
</script>

<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="pa-0">
          <h3 class="d-flex align-center font-weight-bold primary--text text-h6 my-2"><v-icon color="primary" class="mr-2">mdi-account</v-icon> Contact Information</h3>
          <table class="pl-2">
            <tbody>
              <tr v-for="(d, i) in formDataFormatted.info" :key="i">
                <td class="font-weight-bold text-body-1 text-capitalize">{{ d.label }}</td>
                <td>{{ d.value }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
        <v-col cols="12" class="pa-0">
          <h3 class="d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"><v-icon color="primary" class="mr-2">mdi-multimedia</v-icon>Preferred Formats</h3>

          <p v-if="!formDataFormatted?.formats?.length" class="pl-2">No selection provided.</p>
          <template v-else>
            <v-row v-for="f in formDataFormatted.formats" :key="f" no-gutters class="pl-2">
              <v-col cols="12" class="font-weight-bold text-body-1 text-capitalize">{{ f }}</v-col>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" class="pa-0">
          <h3 class="d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"><v-icon color="primary" class="mr-2">mdi-star</v-icon>Genre Interests</h3>

          <table class="pl-2">
            <tbody>
              <tr v-for="(v, g) in formDataFormatted.genres" :key="g">
                <td class="font-weight-bold text-body-1 text-capitalize">{{ v.label }}</td>
                <td>{{ v.value }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
        <v-col cols="12" class="pa-0">
          <h3 class="d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8">
            <v-icon color="primary" class="mr-2">mdi-book-heart</v-icon>Favorite Titles and Authors
          </h3>
          <p v-html="formDataFormatted.questions.favorites" class="font-weight-bold text-body-1 text-capitalize pl-2"></p>
        </v-col>
        <v-col cols="12" class="pa-0">
          <h3 class="d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8">
            <v-icon color="primary" class="mr-2">mdi-book-clock</v-icon>Last Enjoyed Books
          </h3>
          <p v-html="formDataFormatted.questions.last_enjoyed" class="font-weight-bold text-body-1 text-capitalize pl-2"></p>
        </v-col>
        <!-- 
        <v-col cols="12" sm="6" class="d-flex flex-column align-start justify-start">
       
          <v-textarea v-model="formData.questions.last_enjoyed" auto-grow full-width hide-details outlined rows="4" style="width: 100%"></v-textarea>
        </v-col>

        <v-col cols="12" class="my-2">
          <v-sheet min-height="75" width="100%">
            <v-alert :value="!!error" type="error">
              {{ error }}
            </v-alert>
          </v-sheet>
        </v-col>
        <v-col cols="12" class="px-4 mt-8">
          <v-btn block color="primary" :loading="isLoading" type="submit" class="submit-btn mx-auto">SUBMIT</v-btn>
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  td {
    width: auto;
    padding-right: 24px;
    white-space: nowrap !important;
  }
</style>
